import { makeCurrentUserQueryKeyPrefix } from 'features/currentUser/currentUserQueries';

function makeBaseKey() {
  return [...makeCurrentUserQueryKeyPrefix(), 'targetAudiences'] as const;
}

export const targetAudiencesQueryKeys = {
  forList: () => [...makeBaseKey(), 'list'] as const,
  forTargetAudienceById: (targetAudienceId: string) =>
    [...makeBaseKey(), 'targetAudienceById', targetAudienceId] as const
};
